<app-container
  *ngIf="(form || initialManualDataValue); else loader" class="flex justify-center"
  ngClass.xs="xs"
  [maxWidth]="maxWidth"
  [noPadding]="handsetService.isXs">
  <div fxLayout="row">

    <mat-card class="card" ngClass.xs="xs"
              *ngIf="!handsetService.isMobile && base64Src"
              style="margin-right: 1rem">
      <div *ngIf="base64Src" style="display: block; max-width: 500px; width: 500px; padding: 8px; ">
        <ngx-extended-pdf-viewer [base64Src]="base64Src"
                                 [showPrintButton]="true"
                                 [language]="'pl'"
                                 useBrowserLocale="true"
                                 [zoom]="'page-width'"
                                 [sidebarVisible]="false">
        </ngx-extended-pdf-viewer>
      </div>
    </mat-card>


    <mat-card class="card"
              ngClass.xs="xs"
              [ngStyle]="!handsetService.isMobile ? {'padding': '2rem 2rem 1rem 2rem'} : {'padding-top': '0'}">
      <div *ngIf="urlSafe" class="file">
        <div class="preview">
          <iframe
            [src]="urlSafe"
            (contextmenu)="blockEvent($event)"
            (touchstart)="onTouchStart($event)"
            (touchend)="onTouchEnd($event)"
            (dragstart)="blockEvent($event)"
            scrolling="no"
            title="File pdf" width="82px" height="114px"></iframe>
          <div class="zoom-container">
            <div *ngIf="handsetService.isNotMobile" class="zoom-circle" (click)="showFile()">
              <app-icon name="zoom_in" color="#19297C"></app-icon>
            </div>
            <div *ngIf="!deviceService.isIOS()" class="zoom-circle" (click)="showFileOnNewScreen()">
              <app-icon name="zoom_out_map" color="#19297C"></app-icon>
            </div>
            <div *ngIf="deviceService.isIOS()" class="zoom-circle" (click)="downloadFile()">
              <app-icon name="cloud_download" color="#19297C"></app-icon>
            </div>
          </div>
        </div>
      </div>

      <div style="display: flex; flex-direction: row">
        <div style="display: block; width: 100%; 'max-width': '516px'">
          <app-add-liability-manual
            *ngIf="showManual"
            [title]="title"
            [subtitle]="subtitle"
            [buttonText]="buttonText"
            [initialValue]="initialManualDataValue">
          </app-add-liability-manual>
          <app-liability-data-scan-confirmation
            *ngIf="!showManual"
            [liabilityAutomaticReadingId]="liabilityAutomaticReadingId"
            [form]="form"
            (modifyClickEvent)="onShowManual($event)"></app-liability-data-scan-confirmation>
        </div>

      </div>
    </mat-card>
  </div>

</app-container>

<ng-template #loader>
  <app-loading></app-loading>
</ng-template>

<app-document-preview
  *ngIf="documentPreviewVisible"
  [url]="url"
  [path]="path"
  [readonly]="true"
  (hidePreview)="documentPreviewVisible = false"
></app-document-preview>
